var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m8.788 1.20997c.448-1.076998 1.976-1.076998 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.52703 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425l-4.627-2.826-4.627 2.826c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.116997-3.52703c-.887001-.76-.415-2.212.748997-2.305l5.404-.433z","fill":"currentColor","fillRule":"evenodd"}));
}

Star.defaultProps = {"fill":"none","height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = Star;

Star.default = Star;
